import { module as BaseModule } from 'modujs'
import { gsap } from 'gsap'

const COMPACT_SCROLL_Y = 48

export default class extends BaseModule {
  constructor(m) {
    super(m)
    this.events = {
      click: {
        background: 'closeMenu',
      },
    }
    this.isCompact = false
    this.onScroll = this.onScroll.bind(this)
  }

  init() {
    this.btns = this.el.querySelectorAll('[data-navigation="btn"]')
    this.btns.forEach((btn, i) => {
      btn.addEventListener('click', () => {
        this.toggleMenu(i)
      })
    })

    this.menus = document.querySelectorAll('[data-navigation="submenu"]')
    this.menus.forEach((menu) => {
      gsap.set(menu, { autoAlpha: 0 })
    })

    this.openState = false
    this.currentIndex = false
    this.isTransiting = false

    this.setTimeline()
    this.setCompactObserver()

    window.headerOffset = this.el.offsetHeight

    // Highway skips same-URL navigations, so page:change never fires —
    // close the panel when any menu link is clicked (incl. current page).
    this.el.querySelector('.c-header__menu')?.addEventListener('click', (e) => {
      if (e.target.closest('a')) this.closeMenu()
    })

    document.addEventListener('page:change', () => {
      this.closeMenu()
    })
  }

  setCompactObserver() {
    // Desktop-only compact header; Lenis updates window scroll when present.
    if (window.lenis) {
      window.lenis.on('scroll', this.onScroll)
    } else {
      window.addEventListener('scroll', this.onScroll, { passive: true })
    }
    this.onScroll()
  }

  onScroll() {
    if (window.matchMedia('(max-width: 1023px)').matches) {
      if (this.isCompact) this.setCompact(false)
      return
    }

    const y = window.lenis?.scroll ?? window.scrollY ?? 0
    this.setCompact(y > COMPACT_SCROLL_Y)
  }

  setCompact(compact) {
    if (compact === this.isCompact) return
    this.isCompact = compact

    if (compact) {
      this.el.setAttribute('data-header', '')
    } else {
      this.el.removeAttribute('data-header')
    }

    window.headerOffset = this.el.offsetHeight
  }

  setTimeline() {
    this.panelTimeline = gsap
      .timeline({
        yoyo: true,
        paused: true,
      })
      .set('.c-header__menu', {
        autoAlpha: 1,
      })
      .to('.c-header__panel', {
        xPercent: '100',
        duration: 0.35,
        ease: 'power1.out',
      })
      .to(
        '.c-header__background',
        {
          autoAlpha: 1,
          duration: 0.35,
          ease: 'power2.out',
        },
        '<',
      )
  }

  toggleMenu(i) {
    if (i === this.currentIndex && this.openState) {
      this.closeMenu(i)
    } else {
      this.openMenu(i)
    }
  }

  async closeMenu() {
    if (!this.openState) return
    this.panelTimeline.reverse()
    this.openState = false
    this.btns.forEach((btn) => btn.setAttribute('aria-expanded', 'false'))
  }

  async openMenu(i) {
    if (!this.openState) {
      this.panelTimeline.play()
      this.openState = true
    }

    const tl = gsap.timeline({ duration: 0.2 })

    if (this.currentIndex !== false) tl.to(this.menus[this.currentIndex], { autoAlpha: 0, duration: 0.1 })
    tl.to(this.menus[i], { autoAlpha: 1 })

    this.currentIndex = i
    this.btns.forEach((btn, i) => btn.setAttribute('aria-expanded', i === this.currentIndex))
  }
}
